// src/services/cofounder/tools/index.js
import { getRegisteredTools } from './ToolRegistry';
import { registerDataTools } from './dataTools';
import { registerNetworkTools } from './networkTools';
import { registerAnalysisTools } from './analysisTools';
import { registerActionTools } from './actionTools';

let initialized = false;

/**
 * Initialize and return all registered tools
 * @returns {Array}
 */
export function getToolRegistry() {
  if (!initialized) {
    registerDataTools();
    registerNetworkTools();
    registerAnalysisTools();
    registerActionTools();
    initialized = true;
  }
  return getRegisteredTools();
}

export { executeToolCall } from './toolExecutor';
export { getTool, getToolsByCategory } from './ToolRegistry';
